import React, { useEffect, useMemo, useState } from "react";
import styles from "./index.module.css";
import { useDispatch, useSelector } from "react-redux";
import Modal from "../../Components/Modal";
import { ImLocation } from "react-icons/im";
import { useTranslation } from "react-i18next";
import { updateShifterBookedTrip } from "../Home/homeActions";
import PatientTrip from "./PatientTrip";
import GenericTrip from "./GenericTrip";
import { useNavigate } from "react-router-dom";
import PatientTransport from "../Transports/PatientTransport";
import GenericTransport from "../Transports/GenericTransport";
import { TRIP_STATUS } from "../../helpers/constants";
import SwipeButton from "../../Components/SwipeButton";

const TripAssigned = () => {
  const { type: taskType = "", clubbed_trip: clubbedTrips = [] } = useSelector(
    (state) => state.home.tripDetails
  );

  const { id: userId = "" } = useSelector((state) => state.login.user);

  const {
    destination_details: destinationDetails = [],
    origin = {},
    type: tripType = "",
    status = "",
    shifter_type: shifterType = "",
    accepted_shifter_ids: acceptedShifters = [],
  } = clubbedTrips?.[0] || [];

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [isReject, toggleReject] = useState(false);

  const isShifterTrip = useMemo(() => {
    const {
      status = "",
      is_shifter_booked_trip: isShifterBookedTrip = false,
      shifter_type: shifterType = "",
    } = clubbedTrips?.[0] || {};
    return (
      isShifterBookedTrip &&
      status === TRIP_STATUS.STARTED_SHIFTING &&
      shifterType === "primary"
    );
  }, [clubbedTrips]);

  return (
    taskType === "clubbed_trip" &&
    clubbedTrips.length > 0 && (
      <div className={styles.trip_assigned}>
        {isShifterTrip ? (
          <Modal fullModal fromBottom>
            <main className={styles["local_movements"]}>
              <h2 className={styles["local_movements-title"]}>
                {t("Trip Details")}
              </h2>
              <section className={styles["local_movements__area-container"]}>
                <span className={styles["local_movements__container-head"]}>
                  <ImLocation size={24} color="#2C4861" />
                  <label>{t("Pickup location")}</label>
                </span>
                <div className={styles["local_movements__container-selected"]}>
                  <label>{origin?.area?.name}</label>
                  <label>{`${origin?.floor?.name}, ${origin?.building?.name}`}</label>
                </div>
              </section>
              <section className={styles["local_movements__area-container"]}>
                <span className={styles["local_movements__container-head"]}>
                  <ImLocation size={24} color="#2C4861" />
                  <label>{t("Destination")}</label>
                </span>
                <div className={styles["local_movements__container-selected"]}>
                  <label>{destinationDetails?.[0]?.area?.name}</label>
                  <label>{`${destinationDetails?.[0]?.floor?.name}, ${destinationDetails?.[0]?.building?.name}`}</label>
                </div>
              </section>
              <SwipeButton
                onComplete={() => {
                  toggleReject(true);
                  dispatch(
                    updateShifterBookedTrip(clubbedTrips[0]?.id, () =>
                      toggleReject(false)
                    )
                  );
                }}
                label={t("Trip completed")}
                loader={isReject}
              />
            </main>
          </Modal>
        ) : tripType === "patient" ? (
          !acceptedShifters?.includes(userId) ? (
            <PatientTrip tripDetails={clubbedTrips?.[0]} />
          ) : (
            <PatientTransport />
          )
        ) : !acceptedShifters?.includes(userId) ? (
          <GenericTrip tripDetails={clubbedTrips?.[0]} />
        ) : (
          <GenericTransport />
        )}
      </div>
    )
  );
};

export default TripAssigned;
